<template>
  <div>
    <h1>
      {{ header }}
    </h1>

    <template v-if="!isValidCategory">
      <category-info-block v-for="(category, key) in categories" :category="category" :categoryId="key" />
    </template>

    <template v-if="isValidCategory">
      <div class="category-metadata">
        {{ category.quota }} blocks/day
        <br />
        <div class="block" :style="blockColorString" />
      </div>

      <edit-category-trigger :categoryId="category.id" />

      <div class="category-stats">
        <br />
        Category Stats
        <ul>
          <li>- Total number of blocks completed</li>
          <li>- Graph of daily completions</li>
          <li>- Schedule</li>
          <li>- Milestone/long-term goal</li>
          <li>- Intentional hours</li>
          <li>{{ category.summaries }}</li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
// TODO - prettier URL

import EditCategoryTrigger from "../components/EditCategoryTrigger.vue";
import CategoryInfoBlock from "../components/CategoryInfoBlock.vue";

import db from "../db.js";
import util from "../util.js";

export default {
  name: "category-view",
  components: {
    "category-info-block": CategoryInfoBlock,
    "edit-category-trigger": EditCategoryTrigger,
  },
  props: ["categories"],
  created() {
    console.warn("LOAD CATEGORY SUMMARIES PLEASE!");
    db.loadCategorySummaries(this.category.id);
  },
  computed: {
    header() {
      return this.isValidCategory ? this.category.name : "Categories";
    },
    isValidCategory() {
      let categoryId = this.$route.params.id;
      return typeof this.categories[categoryId] != "undefined";
    },
    category() {
      return this.isValidCategory ? this.categories[this.$route.params.id] : {};
    },
    blockColorString() {
      return "background-color: " + util.colors[this.category.color]; //FIXME - Add checking here for valid colors
    },
  },
};
</script>

<style scoped>
.flexRow {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// CategoryView.vue?708797b4